module.exports = __webpack_public_path__ + "static/media/moolah-gif-min.281ae278.gif";